import { render, staticRenderFns } from "./DettagliAttivita.vue?vue&type=template&id=3e0bf872"
import script from "./DettagliAttivita.vue?vue&type=script&lang=js"
export * from "./DettagliAttivita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports